import XHR from "@/request/http";
const $h = new XHR();
// url
const url = {
  page: "/admin/v1/agents/page",
  list: "/admin/v1/agents/list",
  save: "/admin/v1/agents/save",
  delete: "/admin/v1/agents/delete",
  detail: "/admin/v1/agents/deteil",
};

export async function listAgent(data) {
  return $h.request(url.list, data, "GET");
}

export async function saveAgent(data) {
  return $h.request(url.save, data, "POST");
}

export async function deleteAgent(data) {
  return $h.request(url.delete + "/" + data.id, data, "POST");
}

export async function detailAgent(data) {
  return $h.request(url.detail + "/" + data.id, data, "GET");
}
